import type { SearchScope } from "owa-search-service";
import { allPstFilesSearchScope, SearchScopeKind } from "owa-search-service";

export default function getAllPstFilesMenuItemScope(selectedSearchScope: SearchScope, initialSearchScope: SearchScope): SearchScope {
    if (selectedSearchScope.kind === SearchScopeKind.AllPstFiles &&
        initialSearchScope.kind === SearchScopeKind.PstFile) {
        return initialSearchScope;
    }
    
    return allPstFilesSearchScope({
        kind: SearchScopeKind.AllPstFiles,
    });
}
